import Checkbox from './src/checkbox'

export default Checkbox